import React from 'react';

function Fit({ size, ...otherProps }) {
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore TS(2783): 'stroke' is specified more than once, so this usag... Remove this comment to see the full error message
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M3 11V6a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2h-4M7.5 20h-4v-4M4 19.5L7.5 16" />
      <path d="M10 9.5h4v4M13.5 10L10 13.5" />
    </svg>
  );
}

export default Fit;
